import type { CancelPopupText } from '../../../common/CancelPopup/CancelPopup';
import { translate } from '../../../common/helpers/translate.helper';

interface GetRfqCancelPopupTextProps {
    hasQuotedOffers: boolean;
    isMultipleOffersEnabled: boolean;
    offerCount: number;
}

export const getRfqCancelPopupText = ({
    hasQuotedOffers,
    isMultipleOffersEnabled,
    offerCount,
}: GetRfqCancelPopupTextProps): CancelPopupText => {
    if (!hasQuotedOffers) {
        return {
            headline: translate('offer.detail.header.actions.cancelPopup.enquiry.headline'),
            description: translate('offer.detail.header.actions.cancelPopup.enquiry.optionalReasonDescription'),
            buttonText: translate('offer.detail.header.actions.cancelPopup.enquiry.button'),
        };
    }

    if (!isMultipleOffersEnabled || offerCount <= 1) {
        return {
            headline: translate('offer.detail.header.actions.cancelPopup.quoted.headline'),
            description: translate('offer.detail.header.actions.cancelPopup.quoted.optionalReasonDescription'),
            buttonText: translate('offer.detail.header.actions.cancelPopup.quoted.button'),
        };
    }

    return {
        headline: translate('rfq.detail.cancelPopup.cancelAllOffers.headline'),
        description: translate('rfq.detail.cancelPopup.cancelAllOffers.optionalReasonDescription'),
        buttonText: translate('rfq.detail.cancelPopup.cancelAllOffers.button'),
    };
};
